<h1 id="tableLabel">Blackboxes</h1>

<p>This component demonstrates fetching data from the server.</p>

@if (!blackBoxes) {
  <p><em>Loading...</em></p>
}

@if (blackBoxes) {
  <table class='table table-striped' aria-labelledby="tableLabel">
    <thead>
      <tr>
        <th>Imei Number</th>
        <th>Vehicle Registration</th>
        <th>customerDescription</th>
        <th>isActive</th>
      </tr>
    </thead>
    <tbody>
      @for (blackbox of blackBoxes; track blackbox) {
        <tr>
          <td>{{ blackbox.imeiNumber }}</td>
          <td>{{ blackbox.vehicleRegistration }}</td>
          <td>{{ blackbox.customerDescription }}</td>
          <td>{{ blackbox.isActive }}</td>
        </tr>
      }
    </tbody>
  </table>
}
